var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zoom_svg__a",
    d: "M31.29 14.382l-2.725-.122c-.925-.041-1.708-.825-1.75-1.75a1.505 1.505 0 011.6-1.6l7.107.318c.925.042 1.708.825 1.75 1.75l.318 7.107a1.505 1.505 0 01-1.6 1.6c-.925-.042-1.709-.825-1.75-1.75l-.122-2.724L16.71 34.618l2.724.122c.925.041 1.708.825 1.75 1.75a1.505 1.505 0 01-1.6 1.6l-7.107-.318c-.925-.042-1.708-.825-1.75-1.75l-.318-7.107a1.505 1.505 0 011.6-1.6c.925.042 1.709.825 1.75 1.75l.122 2.724L31.29 14.382z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "zoom_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zoom_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#zoom_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#868686",
    mask: "url(#zoom_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0zMS4yOSAxNC4zODJsLTIuNzI1LS4xMjJjLS45MjUtLjA0MS0xLjcwOC0uODI1LTEuNzUtMS43NWExLjUwNSAxLjUwNSAwIDAgMSAxLjYtMS42bDcuMTA3LjMxOGMuOTI1LjA0MiAxLjcwOC44MjUgMS43NSAxLjc1bC4zMTggNy4xMDdhMS41MDUgMS41MDUgMCAwIDEtMS42IDEuNmMtLjkyNS0uMDQyLTEuNzA5LS44MjUtMS43NS0xLjc1bC0uMTIyLTIuNzI0TDE2LjcxIDM0LjYxOGwyLjcyNC4xMjJjLjkyNS4wNDEgMS43MDguODI1IDEuNzUgMS43NWExLjUwNSAxLjUwNSAwIDAgMS0xLjYgMS42bC03LjEwNy0uMzE4Yy0uOTI1LS4wNDItMS43MDgtLjgyNS0xLjc1LTEuNzVsLS4zMTgtNy4xMDdhMS41MDUgMS41MDUgMCAwIDEgMS42LTEuNmMuOTI1LjA0MiAxLjcwOS44MjUgMS43NSAxLjc1bC4xMjIgMi43MjRMMzEuMjkgMTQuMzgyeiIvPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNDh2NDhIMHoiLz48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48dXNlIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjYSIvPjxnIGZpbGw9IiM4Njg2ODYiIG1hc2s9InVybCgjYikiPjxwYXRoIGQ9Ik0wIDBoNDh2NDhIMHoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgZoom as ReactComponent };